import { Formik, getIn, useFormikContext } from "formik";
import { FC, useEffect, useState } from "react";


import { CreateMyAirdropWalletSelectionFormValues, createMyAirdropWalletSelectionFormValidationSchema, createMyAirdropWalletSelectionFormValuesInitialValue } from ".";
import { Box, Card, CardContent, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import { ApiWallet, useAddWalletMutation, useUpdateAllowAirdropMutation, useWalletsListQuery, useWalletsQuery } from "../../../../store/models/users";
import { successNotificationFromPromise } from "../../../../store/notifications/utils";
import { processErrorFromPromise } from "../../../../store/errors/utils";
import { H2 } from "../../../../components/typography";
import { PrimaryButton } from "../../../../components/button";
import { WalletsActions } from "../../../../store/wallets/actions";
import { useDispatch } from "react-redux";

const AutoSubmit = () => {
    /*
      This component is used to automatically submit the form when the form is valid
      and has been changed(dirty).
     */
    const { isValid, values, dirty, submitForm } = useFormikContext()

    useEffect(() => {
        if (isValid && dirty) {
            submitForm();
        }
    }, [isValid, values, dirty, submitForm])

    return null
}

interface CreateMyAirdropWalletSelectionFormProps {
    userId: string;
}
export const MyAirdropWalletSelectionForm: FC<CreateMyAirdropWalletSelectionFormProps> = ({ userId }) => {

    const dispatch = useDispatch();
    const [setWalletForAirdrop] = useUpdateAllowAirdropMutation();
    // const { t } = useTranslation();
    const [disableButton, setDisableButton] = useState<boolean>(false);
    // const { data: walletsList } = useWalletsListQuery({ userId: userId }, { refetchOnMountOrArgChange: true });
    const { data: wallets } = useWalletsQuery({ userId: userId, page: 0, size: 100 }, { refetchOnMountOrArgChange: true });
    return (

        <>
            {/* <pre>{JSON.stringify(wallets && wallets.content, null, 2)}</pre> */}
            {wallets &&
                <Formik<CreateMyAirdropWalletSelectionFormValues>
                    enableReinitialize
                    initialValues={{
                        ...createMyAirdropWalletSelectionFormValuesInitialValue(
                            wallets.content?.find((w: ApiWallet) => w.chain === 'ETH' && w.allowAirdrop === true)?.id,
                            wallets.content?.find((w: ApiWallet) => w.chain === 'MATIC' && w.allowAirdrop === true)?.id,
                            wallets.content?.find((w: ApiWallet) => w.chain === 'SOL' && w.allowAirdrop === true)?.id
                        ),
                    }}
                    validationSchema={createMyAirdropWalletSelectionFormValidationSchema(
                    )}
                    onSubmit={async (values, { resetForm }): Promise<void> => {
                        try {

                            setDisableButton(true);

                            const erc: ApiWallet | undefined = wallets?.content.find(w => w.id === values.erc20AddressId);
                            const matic: ApiWallet | undefined = wallets?.content.find(w => w.id === values.maticAddressId);
                            const sol: ApiWallet | undefined = wallets?.content.find(w => w.id === values.solAddressId);

                            console.log(JSON.stringify(erc))
                            console.log(JSON.stringify(matic))
                            console.log(JSON.stringify(sol))
                            const walletId = erc && erc.allowAirdrop === false && values.erc20AddressId ? values.erc20AddressId : matic && matic.allowAirdrop === false && values.maticAddressId ? values.maticAddressId : sol && sol.allowAirdrop === false && values.solAddressId ? values.solAddressId : '';
                            console.log(JSON.stringify(walletId))

                            setWalletForAirdrop({ userId: userId, walletId: walletId, allowAirdrop: true })
                                .unwrap()
                                .then(
                                    successNotificationFromPromise('Address added successfully'),
                                )
                                .then(() => {
                                    resetForm();
                                    dispatch(WalletsActions.resetWallets());
                                }
                                )
                                .catch(processErrorFromPromise
                                ).finally(() => {
                                    setDisableButton(false);
                                })

                        } catch (err) {
                            console.log(err);
                        }
                    }}
                >
                    {({
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                        values,
                        setFieldValue,
                        errors,
                        touched,
                        submitForm
                    }): JSX.Element => (
                        <>
                            {/* <pre>{JSON.stringify(history, null, 2)}</pre> */}
                            {/* <pre>{JSON.stringify(touched, null, 2)}</pre> */}
                            {/* <pre>{JSON.stringify(errors, null, 2)}</pre> */}
                            {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                            {wallets.content && <Box sx={{}}>
                                <form noValidate onSubmit={handleSubmit}>
                                    <AutoSubmit />

                                    <Grid container spacing={1}>
                                        <Grid item xs={12}>
                                            <small>
                                                <H2>My AirDrop wallet selection</H2>
                                            </small>
                                        </Grid>


                                        <Grid item xs={12} sm={6} lg={4} style={{ alignItems: 'center', display: 'flex' }}>
                                            <Typography variant="body2">For ERC20 AirDrops use:</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} lg={8}>
                                            <FormControl variant="outlined" fullWidth margin='dense'>
                                                <Select
                                                    disabled={disableButton}
                                                    name={'erc20AddressId'}
                                                    value={getIn(values, 'erc20AddressId')}
                                                    onChange={handleChange}
                                                >
                                                    <MenuItem disabled ></MenuItem>
                                                    {wallets.content.filter(w => w.chain === 'ETH').map((wallet) => {
                                                        return <MenuItem key={wallet.id} value={wallet.id}>{wallet.address}</MenuItem>
                                                    })}
                                                </Select>

                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={6} lg={4} style={{ alignItems: 'center', display: 'flex' }}>
                                            <Typography variant="body2">For Polygon AirDrops use:</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} lg={8}>
                                            <FormControl variant="outlined" fullWidth margin='dense'>
                                                <Select
                                                    disabled={disableButton}
                                                    value={getIn(values, 'maticAddressId')}
                                                    name={'maticAddressId'}
                                                    onChange={handleChange}
                                                >
                                                    <MenuItem disabled ></MenuItem>
                                                    {wallets.content.filter(w => w.chain === 'MATIC').map((wallet) => {
                                                        return <MenuItem key={wallet.id} value={wallet.id}>{wallet.address}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={6} lg={4} style={{ alignItems: 'center', display: 'flex' }}>
                                            <Typography variant="body2">For Solana AirDrops use:</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} lg={8}>
                                            <FormControl variant="outlined" fullWidth margin='dense'>
                                                <Select
                                                    disabled={disableButton}
                                                    value={getIn(values, 'solAddressId')}
                                                    name={'solAddressId'}
                                                    onChange={handleChange}
                                                >
                                                    <MenuItem disabled ></MenuItem>
                                                    {wallets.content.filter(w => w.chain === 'SOL').map((wallet) => {
                                                        return <MenuItem key={wallet.id} value={wallet.id}>{wallet.address}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>

                                    {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <PrimaryButton
                                            disabled={disableButton}
                                            type="submit">Save</PrimaryButton>
                                    </Box> */}

                                </form>
                            </Box>
                            }
                        </>
                    )}
                </Formik >}
        </>
    );
};